<template>
	<div id="excel-wrapper" class="xlsxWrapper">
		<span v-for="(html, i) in tables" :key="i" v-html="html"></span>
	</div>
</template>

<script>
import XLSX from 'xlsx';
import constants from '@/api';
// import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { setTimeout, clearTimeout } from 'timers';
import axios from 'axios';
export default {
	created() {},
	components: {},
	data() {
		return {
			tables: [],
		};
	},
	methods: {},
	computed: {},
	mounted() {
		const CancelToken = axios.CancelToken;
		let cancel, timeout;
		try {
			axios({
				method: 'get',
				headers: {
					Authorization: this.$store.getters.authToken,
				},
				url:
					constants.UTILITY_OG_FILE +
					'?uuid=' +
					this.selectedFile.filename.split('.')[0],
				responseType: 'arraybuffer',
				cancelToken: new CancelToken(function(c) {
					cancel = c;
					// console.log(c);
				}),
			})
				.then(res => {
					clearTimeout(timeout);
					var workbook = XLSX.read(res.data, { type: 'buffer' });
					/* DO SOMETHING WITH workbook HERE */
					for (let sheet in workbook.Sheets) {
						try {
							this.tables.push(
								String(XLSX.utils.sheet_to_html(workbook.Sheets[sheet]))
							);
						} catch (e) {
							console.log(e);
						}
					}
				})
				.catch(e => {
					console.log('Xlsx display error', e);
				});
			timeout = setTimeout(() => {
				cancel();
			}, 5000);
		} catch (e) {
			console.log('Xlsx display error', e);
		}
	},
	props: ['selectedFile'],
};
</script>

<style lang="scss" scoped>
.xlsxWrapper {
	width: 100%;
	overflow: scroll;
	padding: 1% 0 0 1%;
}
</style>

<style>
#excel-wrapper table {
	max-width: 100%;
	border-top: 1px solid gray;
}

#excel-wrapper td {
	border-bottom: 1px solid gray;
	border-right: 1px solid gray;
	padding-left: 10px;
	padding-right: 10px;
	padding-top: 0;
	padding-bottom: 0;
}

#excel-wrapper tr td:first-child {
	border-left: 1px solid gray;
	min-width: 200px;
}
</style>
